import React, { useState } from "react";
import {
  BlueBirdTheme, Button, Header, Typography,
} from "@kitbird/core";
import {
  HeaderWrapper,
  UsernameWrapper,
} from "./FloatHeader.style";
import Modal from "../Modal";
import useAuth from "../Authentication/useAuth";

const FloatHeader = () => {
  const { userAccount, logout } = useAuth();
  const [isLogoutModal, setLogoutModal] = useState(false);
  return (<>
    <HeaderWrapper>
      <Header
        handleLogout={() => setLogoutModal(true)}
      >
        <UsernameWrapper>
          {userAccount.employee_name}
        </UsernameWrapper>
      </Header>
    </HeaderWrapper>
    <Modal
      isOpen={isLogoutModal}
      setOpen={() => setLogoutModal(false)}
      body="Apakah anda yakin ingin keluar dari BBOne Dashboard?"
      title="Konfirmasi Keluar"
      footer={<>
        <Button type="button" variant="text" onClick={() => setLogoutModal(false)}>
          <Typography level={5} color={BlueBirdTheme.colors.primary[500]} fontWeight="bold">
            Batal
          </Typography>
        </Button>
        <Button
          color={BlueBirdTheme.colors.white}
          backgroundColor={BlueBirdTheme.colors.danger[500]}
          onClick={logout}
        >
          <Typography level={5} color="white" fontWeight="bold">
            Keluar
          </Typography>
        </Button>
      </>}
    />
  </>);
};

export default FloatHeader;
